import type { CompanyFilters } from "../../types";
import type { ItSpendSlice } from "./slice";

export function toCompanyFilters(slice: ItSpendSlice): Partial<CompanyFilters> {
  const spend = slice.rows
    .filter((row) => {
      // Only include rows with a categoryId AND at least one value (min or max)
      return (
        !!row.categoryId && (row.min !== undefined || row.max !== undefined)
      );
    })
    .map((row) => ({
      categoryId: row.categoryId as string,
      min: row.min,
      max: row.max,
    }));

  return spend.length > 0 ? { spend } : {};
}

export function fromCompanyFilters(filters: CompanyFilters): ItSpendSlice {
  const rows =
    filters.spend
      ?.filter((row): row is NonNullable<typeof row> => !!row)
      .map((row) => ({
        categoryId: row.categoryId ?? undefined,
        min: row.min ?? undefined,
        max: row.max ?? undefined,
      })) ?? [];

  return { rows: rows.length > 0 ? rows : [{}] };
}
